import * as zod from 'zod';

import { CartesianPose } from '@sb/geometry';
import { CollisionBoxConfig } from '@sb/integrations/types/CollisionBox';
import { EndEffectorConnector } from '@sb/integrations/types/EndEffectorConnector';

import { getDefaultTooltipTransform } from '../constants';
import { schunkEGxVariantInfo } from '../utils/schunkEGxVariantInfo';

import { SchunkEGxVariant } from './SchunkEGxVariant';

const defaults = schunkEGxVariantInfo('EGU 60-MB-M-B');

export const SchunkEGxConfiguration = zod.object({
  kind: zod.literal('SchunkEGx'),
  name: zod.string().default('EGU / EGK'),
  variant: SchunkEGxVariant.default(defaults.variant),
  zeroPositionOffset: zod.number().default(defaults.zeroPositionOffset),
  minPosition: zod.number().default(defaults.minPosition),
  maxPosition: zod.number().default(defaults.maxPosition),
  tcpTransform: CartesianPose.default(
    getDefaultTooltipTransform(defaults.variant),
  ),
  hasQuickChanger: zod.boolean().default(false),
  connector: EndEffectorConnector,
  collisionBox: CollisionBoxConfig.optional(),
});

export type SchunkEGxConfiguration = zod.infer<typeof SchunkEGxConfiguration>;
